import { appInsights } from '../services/ApplicationInsightsService';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

/**
 * Unified App Insights logger for authentication & API actions.
 * Each call creates a custom event and (optionally) an exception entry.
 */
export const logAppEvent = (name, properties = {}, severity = SeverityLevel.Information) => {
  try {
    appInsights.trackEvent({ name }, properties);
  } catch (error) {
    console.warn('AppInsights trackEvent failed:', error);
  }
};

export const logAppError = (error, context = 'General') => {
  const message = typeof error === 'string' ? error : error?.message || 'Unknown error';
  appInsights.trackException({
    error: new Error(`${context}: ${message}`),
    severityLevel: SeverityLevel.Error
  });
  console.error(`${context}_Error`, { message, stack: error?.stack || '' });
  logAppEvent(`${context}_Error`, { message, stack: error?.stack || '' }, SeverityLevel.Error);
};

export const logAuthStep = (step, details = {}) => logAppEvent(`Auth_${step}`, details);
export const logBackendStep = (step, details = {}) => logAppEvent(`Backend_${step}`, details);
